export class Error404Component {

}

export let error404 = {
    template: `<div translate="application.error.pageNotFound"></div>`,
    controller: Error404Component,
    controllerAs: "e404"
};


// WEBPACK FOOTER //
// ./src/main/ui/core/components/blank/error404.component.ts